/*
 * @Author: LiuMeiYu
 * @Date: 2023-05-19 13:32:39
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-24 09:43:56
 * @FilePath: \nexcross_b\src\api\login.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import request from "@/utils/request";
import service from "@/utils/request";
import { getRefreshToken } from "@/utils/auth";

// 登录方法
export function login(username, password) {
  const data = {
    username,
    password,
  };
  return request({
    url: "member/auth/login",
    method: "post",
    data: data,
  });
}
// 登录方法
export function logout() {
  return request({
    url: "member/auth/logout",
    method: "post",
  });
}
// 刷新访问令牌
export function refreshToken() {
  return service({
    url: "member/auth/refresh-token?refreshToken=" + getRefreshToken(),
    method: "post",
  });
}
